var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"approveBox"},[_c('qx-card',{attrs:{"title":_vm.title}},[_c('qx-custom-form',{ref:"baseForm",attrs:{"noSubBtn":true,"formData":_vm.baseForm}}),_c('SubBtnBox',{on:{"sub":_vm.sub}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }